import {
	Form, Modal, Select
}from "antd"
import React, {
	useEffect, useState
}from "react"
import Scrollbars from "react-custom-scrollbars"
import {
	useSelector
}from "react-redux"
import CustomButton from "../../components/CustomButton"
import CustomEditor from "../../components/CustomEditor"
import CustomInput from "../../components/CustomInput"
import CustomSelect from "../../components/CustomSelect"

const ModalCreateHelp = ({ isVisibleModalCreateHelp, helpTags, setIsVisibleModalCreateHelp, createHelp, updateHelp, changeableHelp, setChangeableHelp, helpTag, setHelpTag }) => {
	const { tagChanged, isSending } = useSelector((state) => state.helpSectionReducer)
	const [htmlText, setHtmlText] = useState(null)
	const [initialHtml, setInitialHtml] = useState(null)
	const [form] = Form.useForm()
	useEffect(() => {
		if (changeableHelp){
			form.setFieldsValue({
				title     : changeableHelp.title,
				helpTagId : changeableHelp.helpTagId.toString(),
				content   : changeableHelp.content
			})
			setInitialHtml(changeableHelp.htmlText)
		}
	}, [changeableHelp])

	useEffect(() => {
		if (helpTag){
			form.setFieldsValue({
				helpTagId: helpTag
			})
		}
	}, [helpTag])

	const handleOkModal = () => {
		form.validateFields().then((values) => {
			if (!changeableHelp){
				createHelp({ ...values,
					htmlText: htmlText })
			}
			else {
				updateHelp({ ...values,
					htmlText : htmlText,
					id       : changeableHelp.id })
			}
		})
	}

	useEffect(() => {
		handleCancelModalCreateHelp()
	}, [tagChanged])

	const handleCancelModalCreateHelp = () => {
		setIsVisibleModalCreateHelp(false)
		setChangeableHelp(null)
		setHtmlText(null)
		setInitialHtml(null)
		setHelpTag(null)
		form.resetFields()
	}

	// const setHtmlTextHelp = (htmlText, text) => {
	// 	form.setFieldsValue({ htmlText : htmlText,
	// 		content  : text })
	// }

	const onEditorTextChanged = (htmlText, text) => {
		form.setFieldsValue({
			content: text
		})
		setHtmlText(htmlText)
	}

	return (
		<Modal
			destroyOnClose
			footer={ [
				(
					<CustomButton
						key="saveHelp"
						loading={ isSending }
						onClick={ handleOkModal }
					>
						Сохранить
					</CustomButton>
				)
			] }
			title={ `${ changeableHelp ? "Редактирование" : "Создание" } статьи раздела` }
			visible={ isVisibleModalCreateHelp }
			width={ 1300 }
			onCancel={ handleCancelModalCreateHelp }
			onOk={ handleOkModal }
		>
			<Scrollbars
				autoHeight
				autoHide
				autoHeightMax={ 650 }
			>
				<Form
					form={ form }
					labelAlign="left"
					labelCol={ { span: 3 } }
					style={ { width: "99%" } }
					wrapperCol={ {
						span   : 20,
						offset : 1
					} }
				>
					<Form.Item
						label="Тег"
						name="helpTagId"
						rules={ [{ required: true }] }
					>
						<CustomSelect
							showSearch
							optionFilterProp="title"
							placeholder="Выберите тег"
						>
							{ helpTags.filter((tag) => (!changeableHelp ? !tag.isDeleted : true)).map((elem) => {
								return (
									<Select.Option
										key={ elem.id }
										title={ elem.name }
									>
										{ elem.name }
									</Select.Option>
								)
							}) }
						</CustomSelect>
					</Form.Item>
					<Form.Item
						label="Заголовок"
						name="title"
						rules={ [{ required: true }] }
					>
						<CustomInput
							maxLength={ 100 }
							placeholder="Введите заголовок"
						/>
					</Form.Item>
					<Form.Item
						label="Содержание статьи"
						name="content"
						rules={ [
							{ required   : true,
								min        : 5,
								max        : 100000,
								whitespace : true }
						] }
					>
						<>
							<CustomEditor
								initialHtmlContent={ initialHtml }
								onTextChange={ onEditorTextChanged }
							/>
						</>
					</Form.Item>
				</Form>
			</Scrollbars>
		</Modal>)
}

export default ModalCreateHelp